import { ExtraServiceContainer, ExtraServiceOption } from "./ExtraServiceV2";

const ExtraServiceV2 = {
  Container: ExtraServiceContainer,
  Option: ExtraServiceOption,
};

export { ExtraServiceV2 };
